import BrandVariableModel from "@/models/BrandVariables.model";
import { elgiganten } from "./brands";
import { lego } from "./brands/lego";

const brands = {
  "localhost:5173": {
    brandData: elgiganten,
  }, // Set for local development

  "localhost:5174": {
    brandData: elgiganten,
  }, // Set for local development

  "lego.iplay.dk": {
    brandData: lego,
  },

  "192.168.1.153:5173": {
    brandData: elgiganten,
  }, // Set for local development

  default: {
    brandData: elgiganten,
  }, // Fallback to WOG

  // Brands, can be called individualy with getBrandVariables(client)
  TEST: elgiganten,
};

export const getBrandVariables = (client?: string) => {
  if (client) {
    const brandVariables = brands[client];

    //

    return brandVariables as {
      brandData: BrandVariableModel;
    };
  } else {
    const hostname = window.location.host;
    const brandVariables = brands[hostname] || brands["default"];
    return brandVariables as {
      brandData: BrandVariableModel;
    };
  }
};

export const brand = getBrandVariables().brandData;

// Version that compares platform tenantId with profileTenantId to check if user can load data.
// export const brand = (profileTenantId) => {
//   const data = getBrandVariables().brandData;

//   const doesProfileTenantMatchPlatformTenant =
//     data.tenantId === profileTenantId;

//   if (data && doesProfileTenantMatchPlatformTenant) {
//     return data;
//   } else {
//     return toast.error(
//       "Permission to load info denied based on your profile data!"
//     );
//   }
// };
